import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import api from "../../api/api";
import { useProfileStore } from "../../store/useUserStore";
import CourseCard from "../../components/Course/CourseCard";

const dayShortMap: { [key: string]: string } = {
  Monday: "Mon",
  Tuesday: "Tues",
  Wednesday: "Wed",
  Thursday: "Thurs",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

const BranchCourse = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [courses, setCourses] = useState<any>([]);
  const [allCourses, setAllCourses] = useState<any>([]); // Store full course list
  const { t } = useTranslation();
  let { branchId } = useParams();
  const { setHomePageShow, selectedBranchName, setLoading } = useProfileStore();

  useEffect(() => {
    getBranchCourses();
  }, []);

  function getBranchCourses() {
    setLoading(true);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search?mode=branch&branch_id=${branchId}`,
      )
      .then((res) => {
        console.log("res", res.data.data);

        // proceessed course to get day and time
        const processedCourses = res.data.data.courses.map((course: any) => {
          const allDaysSet = new Set<string>();

          course.time_slots?.forEach((timeslot: any) => {
            allDaysSet.add(timeslot.day); // e.g., "Monday"
          });

          const dayOrder = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ];

          const dayShortMap: { [key: string]: string } = {
            Monday: "Mon",
            Tuesday: "Tues",
            Wednesday: "Wed",
            Thursday: "Thur",
            Friday: "Fri",
            Saturday: "Sat",
            Sunday: "Sun",
          };

          const sortedDays = dayOrder
            .filter((day) => allDaysSet.has(day))
            .map((day) => dayShortMap[day]);

          return {
            ...course,
            concatDayArray: sortedDays,
          };
        });

        setAllCourses(processedCourses);
        setCourses(processedCourses);
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(t("server_error"));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setCourses(allCourses); // Show full list when search is empty
    } else {
      const filtered = allCourses.filter(
        (course: any) =>
          course.course_name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setCourses(filtered);
    }
  }, [searchTerm, allCourses]);

  return (
    <div className="pb-28 container">
      <div className="mb-2 grid grid-cols-4 px-2">
        <div>
          <IoIosArrowBack
            size={28}
            color="#000"
            onClick={() => {
              // navigate("/");
              setHomePageShow("academy");
            }}
          />
        </div>
        <div className="text-center col-span-2 text-lg font-medium truncate">
          {selectedBranchName || "-"}
        </div>
        <div></div>
      </div>
      <div className="col-12">
        <div className="flex items-center mb-6">
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="basis-full bg-gray-200 placeholder:text-slate-400 text-slate-700 text-md border border-slate-200 rounded-xl pl-3 py-1 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 focus:shadow"
            placeholder={t("home.search")}
          />
        </div>

        <div>
          {courses.length > 0 ? (
            <div className="grid grid-cols-2 gap-2 item-start">
              {courses.map((branch: any, index: number) => (
                <CourseCard
                  explore={false}
                  course_id={branch.course_branch_id}
                  name={branch.course_name}
                  concatDayArray={branch.concatDayArray}
                  images={branch.images}
                  pricing_packages={branch.pricing_packages}
                  promotions_tag={branch.promotions_tag}
                  schedule={branch.time_slots}
                />
              ))}
            </div>
          ) : (
            <div
              className="col-12 text-center content-center"
              style={{ height: "60vh" }}
            >
              <div className="text-lg font-semibold">
                {t("home.no_results_found")}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BranchCourse;
